import { render, staticRenderFns } from "./MiscellaneousFee.vue?vue&type=template&id=37da6574"
import script from "./MiscellaneousFee.vue?vue&type=script&lang=js"
export * from "./MiscellaneousFee.vue?vue&type=script&lang=js"
import style0 from "./MiscellaneousFee.vue?vue&type=style&index=0&id=37da6574&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports